import {
  getPagedArticles,
  doGetFeaturedArticle,
  updateArticleById,
  getArticleById,
} from '../../configs/environments/firebase/firebaseApp';
import { createStore } from 'redux';
import articlesReducer from '../reducers/articlesReducer';

export const GET_PAGED_ARTICLES = 'GET_PAGED_ARTICLES';
export const GET_FEATURED_ARTICLE = 'GET_FEATURED_ARTICLE';
export const UPDATE_FEATURED_ARTICLE = 'UPDATE_FEATURED_ARTICLE';
export const UPDATE_SELECTED_ARTICLE = 'UPDATE_SELECTED_ARTICLE';
export const UPDATE_ARTICLES = 'UPDATE_SUGGESTED_ARTICLE';
export const SELECT_ARTICLE = 'SELECT_ARTICLE';
export const GET_SUGGESTED_ARTICLES = 'GET_SUGGESTED_ARTICLES';
export const GET_ARTICLE_BY_ID = 'GET_ARTICLE_BY_ID';


const getArticles = (data) => {
  return {
    type: GET_PAGED_ARTICLES,
    data,
  };
};

const featuredArticleLoad = (data) => {
  return {
    type: GET_FEATURED_ARTICLE,
    data,
  };
};
const suggestedArticlesLoad = (data) => {
  return {
    type: GET_SUGGESTED_ARTICLES,
    data,
  };
};

const featuredArticleUpdatedLoad = (data) => {
  return {
    type: UPDATE_FEATURED_ARTICLE,
    data,
  };
};
const selectedArticleUpdatedLoad = (data) => {
  return {
    type: UPDATE_SELECTED_ARTICLE,
    data,
  };
};
const articlesUpdatedLoad = (data) => {
  return {
    type: UPDATE_ARTICLES,
    data,
  };
};

const articleByIdLoad = (data) => {
  return {
    type: GET_ARTICLE_BY_ID,
    data,
  }
}

const articleSelected = (data) => {
  return {
    type: SELECT_ARTICLE,
    data,
  };
};

export const getArticlesByPage = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (params) {
      getPagedArticles(params)
        .then((res) => {
          dispatch(getArticles(res));
          return resolve('success');
        })
        .catch((err) => reject(err));
    } else {
      return reject('fail');
    }
  });
};

export const getSuggestedArticles = (params, id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (params) {
      getPagedArticles(params)
        .then((res) => {
          const articles = res && res.data.filter( article => article.id !== id).slice(0,3)
          dispatch(suggestedArticlesLoad({data: articles}));
          return resolve('success');
        })
        .catch((err) => reject(err));
    } else {
      return reject('fail');
    }
  });
};

export const getFeaturedArticle = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    doGetFeaturedArticle()
      .then((res) => {
        dispatch(featuredArticleLoad(res.data[0]));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const updateFeaturedArticle = (article, userId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let body;
    if (article.like.find((item) => item === userId)) {
      let newLikeArray = [...article.like];
      newLikeArray = newLikeArray.filter((item) => item !== userId)
      body = {
        like: newLikeArray,
        numberLike: article.numberLike - 1,
      };
    } else {
      body = {
        like: [...article.like, userId],
        numberLike: article.numberLike + 1,
      };
    }
    const newArticle = {
      ...article,
      like: body.like,
      numberLike: body.numberLike,
    };

    updateArticleById(article.id, body)
      .then((res) => {
        dispatch(featuredArticleUpdatedLoad(newArticle));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const updateSelectedArticle = (article, userId) => (
  dispatch
) => {
  return new Promise((resolve, reject) => {
    let body;
    if (article.like.find((item) => item === userId)) {
      let newLikeArray = [...article.like];
      newLikeArray = newLikeArray.filter((item) => item !== userId)
      body = {
        like: newLikeArray,
        numberLike: article.numberLike - 1,
      };
    } else {
      body = {
        like: [...article.like, userId],
        numberLike: article.numberLike + 1,
      };
    }
    const newArticle = {
      ...article,
      like: body.like,
      numberLike: body.numberLike,
    };

    updateArticleById(article.id, body)
      .then((res) => {
        dispatch(selectedArticleUpdatedLoad(newArticle));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const updateArticle = (article, articles, userId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let body;
    if (article.like.find((item) => item === userId)) {
      let newLikeArray = [...article.like];
      newLikeArray = newLikeArray.filter((item) => item !== userId)
      body = {
        like: newLikeArray,
        numberLike: article.numberLike - 1,
      };
    } else {
      body = {
        like: [...article.like, userId],
        numberLike: article.numberLike + 1,
      };
    }
    const newArticle = {
      ...article,
      like: body.like,
      numberLike: body.numberLike,
    };

    const mappedSuggestedArticles = articles.suggested && articles.suggested.data ? (
      articles.suggested.data.map((elem) => {
        if (elem.id === newArticle.id) {
          return (elem = {
            ...newArticle,
          });
        }
        return elem;
      })
    ): ( [] )
    const mappedlistArticles = articles.list.data.map((elem) => {
      if (elem.id === newArticle.id) {
        return (elem = {
          ...newArticle,
        });
      }
      return elem;
    });

    const newArticles = {
      ...articles,
      suggested: {
        ...articles.suggested,
        data: mappedSuggestedArticles,
      },
      list: {
        ...articles.list,
        data: mappedlistArticles,
      },
    };
    //console.log('action', , body, article)

    updateArticleById(article.id, body)
      .then((res) => {
        /* const store = createStore(articlesReducer);
        const unsubscribe = store.subscribe(() =>
          console.log(store.getState())
        );
        store.dispatch(suggestedArticleUpdatedLoad(newArticles));
        unsubscribe(); */
        dispatch(articlesUpdatedLoad(newArticles));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const shareFeaturedArticle = (article) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const body = {
      numberShare: article.numberShare + 1,
    };
    const newArticle = {
      ...article,
      numberShare: body.numberShare,
    };

    updateArticleById(article.id, body)
      .then((res) => {
        dispatch(featuredArticleUpdatedLoad(newArticle));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const shareSelectedArticle = (article) => (dispatch) => {
  return new Promise((resolve, reject) => {
    const body = {
      numberShare: article.numberShare + 1,
    };
    const newArticle = {
      ...article,
      numberShare: body.numberShare,
    };

    updateArticleById(article.id, body)
      .then((res) => {
        dispatch(selectedArticleUpdatedLoad(newArticle));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const shareListArticle = (article, articles) => (dispatch) => {
  return new Promise((resolve, reject) => {
    let body;
      body = {
        numberShare: article.numberShare + 1,
      };
    const newArticle = {
      ...article,
      numberShare: body.numberShare,
    };

    const mappedSuggestedArticles = articles.suggested && articles.suggested.data ? (
      articles.suggested.data.map((elem) => {
        if (elem.id === newArticle.id) {
          return (elem = {
            ...newArticle,
          });
        }
        return elem;
      })
    ): ( [] )

    const mappedlistArticles = articles.list.data.map((elem) => {
      if (elem.id === newArticle.id) {
        return (elem = {
          ...newArticle,
        });
      }
      return elem;
    });

    const newArticles = {
      ...articles,
      suggested: {
        ...articles.suggested,
        data: mappedSuggestedArticles,
      },
      list: {
        ...articles.list,
        data: mappedlistArticles,
      },
    };

    updateArticleById(article.id, body)
      .then((res) => {
        dispatch(articlesUpdatedLoad(newArticles));
        return resolve('success');
      })
      .catch((err) => reject(err));
  });
};

export const articleById = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    getArticleById(id)
    .then((res) => {
      dispatch(articleByIdLoad(res.data));
      return resolve('success');
    })
    .catch((err) => reject(err));
    
  });
};

export const selectArticle = (params) => (dispatch) => {
  return new Promise((resolve, reject) => {
    if (params) {
      dispatch(articleSelected(params));
      return resolve('success');
    } else {
      return reject('fail');
    }
  });
};
